export default {
  addNewClass: '新增分类',
  addSubNewClass: '新增子分类',
  edit: '编辑',
  del: '删除',
  addArticle: '新增文章',
  moreHandler: '更多操作',
  allClass: '全部分类（{num}）',
  allStatus: '全部状态',
  choosedContent: '已选中{num}条内容',
  searchArticlePlaceholder: '搜索文章标题',
  articleTitle: '文章标题',
  articleClass: '分类',
  articleStatus: '状态',
  createTime: '创建时间',
  createUser: '创建人',
  handler: '操作',
  detail: '详情',
  online: '上线',
  offline: '下线',
  top: '置顶',
  cancelTop: '取消置顶',
  hot: '热门',
  cancelHot: '取消热门',
  putOn: '已上架',
  putDown: '已下架',
  articleProfile: '文章简介',
  articleAddress: '文章地址',
  belongCategory: '所属分类',
  cancel: '取消',
  save: '保存',
  public: '发布',
  categoryName: '分类名称',
  editCategory: '编辑分类',
  article_url_note_empty: '文章地址',
  category_url_note_empty: '请选择所选分类'
}
